module.exports = __webpack_public_path__ + "static/img/IMG_2683.c112aa9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fotosGaleriaSicarf/IMG_2683.jpg
// module id = 108r
// module chunks = 11